import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OneWebComponentsAngularModule } from '@one/angular';
import { Observable } from 'rxjs';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { SnackbarService } from '../../services/snackbar.service';

export interface LocalNotificationModal{
  LocalNotification:[];
}

export interface LocalNotificationState {
  readonly localNotificationState: LocalNotificationModal[];
}

const NO_DATA_FOUND_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" viewBox="0 0 82 82" fill="none">
<path d="M29.5894 54.0711C43.119 54.0711 54.0869 43.1058 54.0869 29.5794C54.0869 16.053 43.119 5.08765 29.5894 5.08765C16.0597 5.08765 5.0918 16.053 5.0918 29.5794C5.0918 43.1058 16.0597 54.0711 29.5894 54.0711Z" fill="url(#paint0_linear_6628_5860)"/>
<path d="M29.3093 0.0244317C13.1532 0.00687075 0.0410161 13.0839 0.0234552 29.24C0.00589417 45.3903 13.0947 58.4966 29.2508 58.5142C45.4127 58.5318 58.5191 45.4488 58.5366 29.2986C58.5542 13.1425 45.4713 0.0419927 29.3093 0.0244317ZM29.2566 52.5376C16.402 52.5259 5.98833 42.0947 6.00004 29.2459C6.01175 16.3913 16.4488 5.98931 29.3035 6.00102C42.1639 6.01272 52.5717 16.4381 52.56 29.2927C52.5425 42.1415 42.1171 52.5493 29.2566 52.5376Z" fill="#999999"/>
<path d="M50.9049 47.152L47.2656 50.7898L54.3963 57.9235L58.0356 54.2857L50.9049 47.152Z" fill="#999999"/>
<path d="M80.5338 80.5414C78.6197 82.4555 75.5114 82.4555 73.5972 80.5414L51.1719 58.1277L58.1143 51.1912L80.5397 73.6048C82.4538 75.5131 82.4538 78.6214 80.5338 80.5414Z" fill="url(#paint1_linear_6628_5860)"/>
<path d="M45.3715 29.5797C45.3715 29.5797 38.3062 38.2489 29.5959 38.2489C20.8857 38.2489 13.8145 29.5797 13.8145 29.5797C13.8145 29.5797 20.8798 20.9104 29.5901 20.9104C38.3003 20.9104 45.3715 29.5797 45.3715 29.5797Z" fill="white"/>
<path d="M29.5898 35.6559C32.9455 35.6559 35.6659 32.9355 35.6659 29.5798C35.6659 26.224 32.9455 23.5037 29.5898 23.5037C26.234 23.5037 23.5137 26.224 23.5137 29.5798C23.5137 32.9355 26.234 35.6559 29.5898 35.6559Z" fill="#CCCCCC"/>
<path d="M29.5904 32.9921C31.4752 32.9921 33.0031 31.4642 33.0031 29.5794C33.0031 27.6947 31.4752 26.1667 29.5904 26.1667C27.7056 26.1667 26.1777 27.6947 26.1777 29.5794C26.1777 31.4642 27.7056 32.9921 29.5904 32.9921Z" fill="#666666"/>
<defs>
<linearGradient id="paint0_linear_6628_5860" x1="12.0903" y1="12.1472" x2="46.6957" y2="46.8261" gradientUnits="userSpaceOnUse">
<stop stop-color="#CBCDD1"/>
<stop offset="1" stop-color="#E4E5EA"/>
</linearGradient>
<linearGradient id="paint1_linear_6628_5860" x1="51.1723" y1="66.5801" x2="81.9738" y2="66.5801" gradientUnits="userSpaceOnUse">
<stop stop-color="#CBCDD1"/>
<stop offset="1" stop-color="#E4E5EA"/>
</linearGradient>
</defs>
</svg>
`;

export interface StepConfig {
  name: string;
  completed: boolean;
  formGroup: FormGroup;
  template: TemplateRef<any>;
  optional?: boolean;
}

@Component({
  selector: 'app-unique-id-dialog',
  standalone: true,
  imports:[OneWebComponentsAngularModule, CommonModule,FormsModule,ReactiveFormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './unique-id-dialog.component.html',
  styleUrl: './unique-id-dialog.component.scss'
})
export class UniqueIdDialogComponent {
 @ViewChild('firstGroup', { static: true }) public firstGroupTemplate: TemplateRef<any>;
  @ViewChild('secondGroup', { static: true }) public secondGroupTemplate: TemplateRef<any>;
  @ViewChild('stepper', { static: true }) public stepper: any;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns: string[] = ['documentTitle', 'version', 'language', 'date','select'];
  public dataSource = [];
  public dataFlag: boolean = false;
  public isLinear = false;
  public firstFormGroup = this.formBuilder.group({firstCtrl: ['', Validators.required]});
  public secondFormGroup = this.formBuilder.group({secondCtrl: ['', Validators.required]});
  public stepperConfig: StepConfig[];
  public condensed = false;
  public isCreateDisabled = true;
  public searchNotificationId= new FormControl({ value: '', disabled: false }, []);
  public isDisabled = true;
  public isDisabledSearch=true;
  public countriesFormControlOutlinedSmall = new FormControl(null);
  public notificationTypeFormControl= new FormControl(null);
 
  
  public localBasedGlobalNotificationRadioButton = new FormControl(null);
  public countriesList = [];
  public uniqueID: any;
  public suffix: any;
  public globalID: any;
  public localIDformctrl = new FormControl({value: '', disabled: false}, [Validators.minLength(1),]);
  public globalIDformctrl= new FormControl({value: '', disabled: false}, [Validators.minLength(1),]);
  public localIdData: any;
  public flagForLocalIdCheck: boolean=false;
  public flagForglobalIdCheck:boolean=false;
  public selectedRow: any = {};
  public isTableShow:boolean = false;
  public showCreateLocalSection:boolean = false;
  public selectedRadioValue: string | null = null;
  
  // Pagination properties
  public currentPage: number = 1;
  public pageSize: number = 5;
  public totalItems: number = 0;
  public totalPages: number = 0;
  
  public checkCountryForLocalNotification = "";
  public notificationTypeList = [
    {
      label: 'SBN',
      value: 'Safety Board Notification',
      disabled: false
    },
    {
      label: 'QN',
      value: 'Quality Notification',
      disabled: false
    },
    {
      label: 'MN',
      value: 'Marketting Notification',
      disabled: false
    },
    {
      label: 'SN',
      value: 'Support Notification',
      disabled: false
    },
    {
      label: 'SNR',
      value: 'Support Notification With Risk',
      disabled: false
    },
     {
      label: 'Memo',
      value: 'Memo',
      disabled: false
    },
    {
      label: 'LN',
      value: 'Local Notification',
      disabled: false
    }
  ];

  public constructor(
    private router: Router,
    private renderer: Renderer2,
    private qnsbnService: QnSbnService,
    private changeDetectorRef: ChangeDetectorRef,
    private _QnSbnDataService:QnSbnDataServiceService,
    private readonly formBuilder: FormBuilder,
    private snackBarNotification: SnackbarService
  ) {
    this.renderer.addClass(document.body, 'local-notification-config');
    // this.iconRegistry.addSvgIconLiteral('no_data_found', this.sanitizer.bypassSecurityTrustHtml(NO_DATA_FOUND_ICON));
  }

  ngAfterViewInit(): void {   
  //  this.dataSource.paginator = this.paginator;
  }

  public ngOnDestroy() {
    this.renderer.removeClass(document.body, 'local-notification-config');
  }

  public ngOnInit(): void {  
    // Reset form state to ensure clean state on re-open
    this.resetFormState();
    
    // Initialize with countries from screenshots
    const allCountries = [
      { label: "GB", value: "GB" },
      { label: "MT", value: "MT" },
      { label: "IL", value: "IL" },
      { label: "AT", value: "AT" },
      { label: "ES", value: "ES" },
      { label: "AR", value: "AR" },
      { label: "PT", value: "PT" },
      { label: "CA", value: "CA" },
      { label: "HU", value: "HU" },
      { label: "MY", value: "MY" },
      { label: "BE", value: "BE" },
      { label: "PH", value: "PH" }
    ];

    let resultData = [];
    const notificationData = this.qnsbnService.getNotificationData();
    const userInfo = this.qnsbnService.getUserAllData();
    
    // Check if user has specific countries configured
    if(Array.isArray(userInfo)) {
       if (userInfo.length > 0 && userInfo[0] && userInfo[0].countries) {
      userInfo[0].countries.forEach((element: string) => {
        const country = {
          label: element,
          value: element,
        };
        resultData.push(country);
      });
    }
    } else if (userInfo?.countries) {
    userInfo.countries.forEach((element: string) => {
      const country = {
        label: element,
        value: element,
      };
      resultData.push(country);
    });
  }
  
   // If no user-specific countries found, use the countries from screenshots
   if (resultData.length < 1) {
     resultData = allCountries;
   }
   
this.countriesList = resultData;



    this.localIDformctrl.updateValueAndValidity()
    this.countriesFormControlOutlinedSmall.valueChanges.subscribe(inp =>{ 
      this.validateForm();
      this.changeDetectorRef.detectChanges();
     });

    this.localIDformctrl.valueChanges.subscribe(enterText=>{  
      this.validateForm();
      this.changeDetectorRef.detectChanges();
     })


      this.localBasedGlobalNotificationRadioButton.valueChanges.subscribe(radiodata=>{
        if (radiodata === 'local' || radiodata === 'global') {
          this.selectedRadioValue = radiodata;
          if(radiodata === 'global'){
            this.localIDformctrl.setValue('');
          }
          this.isTableShow = false;
          this.validateForm();
          this.changeDetectorRef.detectChanges();
        }
      })

    //global
    this.globalIDformctrl.valueChanges.subscribe(enterText=>{ 
      this.validateForm();
      this.changeDetectorRef.detectChanges();
    })
    this.uniqueID = "SBN-QN-123";
    this.globalID = this.uniqueID;
    
    //glabal
    this.stepperConfig = [
      {
        name: 'Import settings',
        completed: false,
        formGroup: this.firstFormGroup,
        template: this.firstGroupTemplate,
        optional: true
      },
      {
        name: 'Verify changes',
        completed: false,
        formGroup: this.secondFormGroup,
        template: this.secondGroupTemplate
      },
    ];

    this.searchNotificationId.valueChanges.subscribe(dInput=>{
      this.validateSearchForm();    
    });

    this.notificationTypeFormControl.valueChanges.subscribe(inp =>{ 
      this.isTableShow = false;
      this.validateForm();
      this.validateSearchForm();
      this.changeDetectorRef.detectChanges();
    });
    
    // Initial validation
    this.validateForm();
    this.validateSearchForm();
  }
  
  private validateForm(): void {
    let countryValue = this.countriesFormControlOutlinedSmall.value;
    if (Array.isArray(countryValue)) {
      countryValue = countryValue[0];
    }
    const isCountrySelected = countryValue && 
                             countryValue !== "" && 
                             countryValue !== null && 
                             countryValue !== undefined;
    
    let typeValue = this.notificationTypeFormControl.value;
    if (Array.isArray(typeValue)) {
      typeValue = typeValue[0];
    }
    const isTypeSelected = typeValue && 
                          typeValue !== "" && 
                          typeValue !== null &&
                          typeValue !== undefined;
    
    const radioValue = this.selectedRadioValue || this.localBasedGlobalNotificationRadioButton.value;
    let hasValidInput = false;
    const localValue = this.localIDformctrl.value;
    const globalValue = this.globalIDformctrl.value;
    
    if (radioValue === 'local') {
      hasValidInput = typeof localValue === 'string' && localValue.trim() !== '';
    } else if (radioValue === 'global') {
      hasValidInput = this.showCreateLocalSection && typeof globalValue === 'string' && globalValue.trim() !== '';
    }

    // Enable create button only if all conditions are met
    this.isCreateDisabled = !(isCountrySelected && isTypeSelected && hasValidInput);
  }

  private validateSearchForm(): void {
    const hasSearchInput = this.searchNotificationId.value && 
                          this.searchNotificationId.value.trim() !== '';
    const hasTypeSelected = this.notificationTypeFormControl.value !== "" && 
                           this.notificationTypeFormControl.value !== null &&
                           this.notificationTypeFormControl.value !== undefined;
    
    this.isDisabledSearch = !(hasSearchInput && hasTypeSelected);
  }

  public countryCheck(){
    const countryValue = this.countriesFormControlOutlinedSmall.value;
    if(Array.isArray(countryValue) || !countryValue){        
        this.checkCountryForLocalNotification = "";
        return this.checkCountryForLocalNotification;
    }else{
      // The value is now a string directly, not an object with 'value' property
      this.checkCountryForLocalNotification = countryValue;
      return this.checkCountryForLocalNotification;
    }
  }

  public addLocalNotificationId(notifyId) {
    this._QnSbnDataService.getMappedQnsbnData(notifyId,"LocalNotificationId")
  }

  public createLocalGlobalId(){
    this.countryCheck();
   
    
    const localNotificationLanguage = this.qnsbnService.getNotificationLanguage(this.checkCountryForLocalNotification);
    const countryValue = this.countriesFormControlOutlinedSmall.value;
    let country = '';
    if (Array.isArray(countryValue) && countryValue.length > 0) {
     
      country = countryValue[0];
    } else if (typeof countryValue === 'string') {
      country = countryValue;
    } else if (countryValue?.value) {
      country = countryValue.value;
    } else if (countryValue?.label) {
      country = countryValue.label;
    } else {
      country = this.checkCountryForLocalNotification || '';
    }
    
    
    const typeValue = this.notificationTypeFormControl.value;
    let type = '';
    if (Array.isArray(typeValue) && typeValue.length > 0) {
     
      type = typeValue[0];
    } else if (typeof typeValue === 'string') {
      type = typeValue;
    } else if (typeValue?.label) {
      type = typeValue.label;
    } else if (typeValue?.value) {
      type = typeValue.value;
    }
    
    if(this.localBasedGlobalNotificationRadioButton.value=='local'){ 
      let dataObject = {
        'LocalId': this.localIDformctrl.value || '',
        'Country': country,
        'LocalNotificationLanguage': localNotificationLanguage,
        'Type': type
      }; 
      
      sessionStorage.setItem('reloadOverview', 'true');
      this.qnsbnService.createNotificationUniqueId(dataObject).subscribe(
        response=>{
          this.qnsbnService.setLocalNotificationID(response['LocalId']);
          this._QnSbnDataService.resetAll();
          this.addLocalNotificationId(response);
          this.snackBarNotification.snackBarMessage('positive', 'Local Notification ID created');       
          setTimeout(()=>{
            this.router.navigateByUrl("/create-notification")
          },1000)
        },
        (error: HttpErrorResponse) => { //409 conflicts means ID already exist.
          if(error['status'] == 409){
            this.localIDformctrl.setErrors({flagForLocalIdCheck1:false})
            this.localIDformctrl.markAsDirty();
            this.flagForLocalIdCheck = true;
            let errorMessage = 'LocalId and Country combination already exists';
            try {
              if (error.error && error.error.errorMessage) {
                const parsedError = JSON.parse(error.error.errorMessage);
                if (parsedError.body) {
                  errorMessage = parsedError.body;
                }
              } else if (error.error && error.error.body) {
                errorMessage = error.error.body;
              }
            } catch (e) {
            }
            this.snackBarNotification.snackBarMessage('alarm', errorMessage);
            this.changeDetectorRef.detectChanges(); 
          } else{
            this.oncancelNotification();
            this.qnsbnService.httpErrorHandler(error, 'There is some issue in creating local id. Please try again later.');
          }             
        }
      );
    }

    if(this.localBasedGlobalNotificationRadioButton.value=='global'){
      if (!this.selectedRow["PIMID"]) {
        this.snackBarNotification.snackBarMessage('alarm', 'Please add a file from the table.');
        return;
      }
      let localId = this.globalID+this.globalIDformctrl.value ? this.globalID+this.globalIDformctrl.value : "";
      let dataTosend = {
        "PIMID": this.selectedRow["PIMID"],
        "UniqueSourceSystemID": this.selectedRow["UniqueSourceSystemID"]?this.selectedRow["UniqueSourceSystemID"]:"",
        "UniqueSourceDocumentID": this.selectedRow["UniqueSourceDocumentID"]?this.selectedRow["UniqueSourceDocumentID"]:"",
        "FileSize": this.selectedRow["FileSize"]?this.selectedRow["FileSize"]:"",
        "FileExtension": this.selectedRow["FileExtension"]?this.selectedRow["FileExtension"]:"",
        "Title": this.selectedRow["Title"]?this.selectedRow["Title"]:"",
        "Language": this.selectedRow["Language"]?this.selectedRow["Language"]:"en",
        "DocumentTypePIMID": this.selectedRow["DocumentTypePIMID"]?this.selectedRow["DocumentTypePIMID"]:"",
        "VersionNumber": this.selectedRow["VersionNumber"]?this.selectedRow["VersionNumber"]:"",
        "ModifyDate": this.selectedRow["ModifyDate"]?this.selectedRow["ModifyDate"]:"",
        "Subject": this.selectedRow["Subject"]?this.selectedRow["Subject"]:"",
        "IsNewestVersion": this.selectedRow["IsNewestVersion"]?this.selectedRow["IsNewestVersion"]:false,
        "DocumentType": this.selectedRow["DocumentType"]?this.selectedRow["DocumentType"]:"",
        "LocalId": localId,
        "Country": country,
        "LocalNotificationLanguage": localNotificationLanguage
      }
      
    
      this.qnsbnService.createNotificationUniqueId(dataTosend).subscribe(
        res=>{     
          this.qnsbnService.setLocalNotificationID(res['LocalId'])
          this._QnSbnDataService.resetAll();
          this.addLocalNotificationId(res);
          this._QnSbnDataService.getMappedQnsbnData(this.selectedRow,"NotificationDoc");
          this.snackBarNotification.snackBarMessage('positive', 'Local Notification ID created'); 
          setTimeout(()=>{
            this.router.navigateByUrl("/create-notification")
          },1000)
        },
        //409 conflicts means ID already exist.
        //400 Something went wrong in request payload
        (error: HttpErrorResponse) => {
          if(error['status'] == 409){
            this.globalIDformctrl.setErrors({flagForglobalIdCheck:false})
            this.globalIDformctrl.markAsDirty();
            this.flagForglobalIdCheck = true;
            let errorMessage = 'LocalId and Country combination already exists';
            try {
              if (error.error && error.error.errorMessage) {
                const parsedError = JSON.parse(error.error.errorMessage);
                if (parsedError.body) {
                  errorMessage = parsedError.body;
                }
              } else if (error.error && error.error.body) {
                errorMessage = error.error.body;
              }
            } catch (e) {
            }
            this.snackBarNotification.snackBarMessage('alarm', errorMessage);
            this.changeDetectorRef.detectChanges(); 
          }else{
            this.oncancelNotification();
            this.qnsbnService.httpErrorHandler(error, 'There is some issue in creating local id. Please try again later.');
          }  
        }
      );   
    }

  }
 
  toggleComplete() {
    this.stepper.selected.completed = true;
    this.stepperConfig[this.stepper.selectedIndex].completed = true;
    this.stepper.next();
  }

  rowSelection(row){
    this.selectedRow = row;
    this.uniqueID = row['Subject']
    this.globalID = this.uniqueID;
    this.toggleComplete()
  }

  onSerach(){
    let documentTypeValue = Array.isArray(this.notificationTypeFormControl.value) 
                        ? this.notificationTypeFormControl.value[0] 
                        : this.notificationTypeFormControl.value;
    let url = this.searchNotificationId.value +"&documenttype="+documentTypeValue;
    
    // Show table immediately when search is initiated
    this.isTableShow = true;
    this.changeDetectorRef.detectChanges();
    
    this.qnsbnService.uniqueIdPiosDocSearch(url).subscribe(
      d=>{ 
       
             
        ELEMENT_DATA = d;
        this.dataSource = ELEMENT_DATA;
        this.dataFlag = Array.isArray(this.dataSource) && this.dataSource.length > 0;
        this.isTableShow = true;
        this.currentPage = 1; // Reset to first page
        this.updatePagination(); // Update pagination
        
       
        
        this.changeDetectorRef.detectChanges();
        this.ngAfterViewInit();
      },
      error=>{
       
        
        ELEMENT_DATA = [];
        this.dataSource = ELEMENT_DATA;
        this.dataFlag = false; // Set to false on error
        this.isTableShow = true;
        this.currentPage = 1; // Reset to first page
        this.updatePagination(); // Update pagination
        
       
        
        this.changeDetectorRef.detectChanges();
        this.ngAfterViewInit();
        this.qnsbnService.httpErrorHandler(error, 'Could not fetch any document.');
      }
    )
  }

  public onSelectNotification(element?: any){
    // Store the selected row data if needed
    this.selectedRow = element;
    
    // Hide the search/table section and show the create local section
    this.isTableShow = false;
    this.showCreateLocalSection = true;
    
    // Optionally populate the global notification ID if element has data
    if (element && element.Subject) {
      this.uniqueID = element.Subject;
      this.globalID = this.uniqueID;
    } else if (element && element.id) {
      this.uniqueID = element.id;
      this.globalID = this.uniqueID;
    }
    this.validateForm();
    this.changeDetectorRef.detectChanges();
  }

  public goBackToSearch(){
    // Show the search/table section and hide the create local section
    this.showCreateLocalSection = false;
    this.isTableShow = true;
    
    // Optionally clear the selected row
    this.selectedRow = null;
  }

  // Pagination methods
  public updatePagination(): void {
    this.totalItems = this.dataSource ? this.dataSource.length : 0;
    this.totalPages = this.totalItems > 0 ? Math.ceil(this.totalItems / this.pageSize) : 0;
    
    // Reset to first page if current page exceeds total pages or if no data
    if (this.totalPages === 0) {
      this.currentPage = 1;
    } else if (this.currentPage > this.totalPages) {
      this.currentPage = 1;
    }
    
   
  }

  public getPaginatedData(): any[] {
    if (!this.dataSource || this.dataSource.length === 0) {
      return [];
    }
    
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.dataSource.slice(startIndex, endIndex);
  }

  public getStartIndex(): number {
    if (this.totalItems === 0) return 0;
    return (this.currentPage - 1) * this.pageSize;
  }

  public getEndIndex(): number {
    if (this.totalItems === 0) return 0;
    const endIndex = this.currentPage * this.pageSize;
    return Math.min(endIndex, this.totalItems);
  }

  public onPageSizeChange(): void {
    this.pageSize = Number(this.pageSize);
    this.currentPage = 1;
    this.updatePagination();
  }

  public goToFirstPage(): void {
    this.currentPage = 1;
  }

  public goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  public goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  public goToLastPage(): void {
    this.currentPage = this.totalPages;
  }

  oncancelNotification(){
    this.resetFormState();
    this.router.navigateByUrl("/notification");
  }

  public onRadioChange(event: any): void {
    const value = event?.detail?.value || event?.target?.value || event;
    this.selectedRadioValue = value;
    if (value === 'global') {
      this.localIDformctrl.setValue('');
    }
    this.isTableShow = false;
    this.validateForm();
    this.changeDetectorRef.detectChanges();
  }

  public onRadioClick(value: string): void {
    // Immediately set the selected radio value
    this.selectedRadioValue = value;
    this.localBasedGlobalNotificationRadioButton.setValue(value);
    
    // Clear the other input field
    if (value === 'global') {
      this.localIDformctrl.setValue('');
    } else if (value === 'local') {
      this.searchNotificationId.setValue('');
    }
    
    this.isTableShow = false;
    this.validateForm();
    
    // Force Angular to detect the change
    this.changeDetectorRef.markForCheck();
    this.changeDetectorRef.detectChanges();
  }

  public onLocalIdInput(event: any): void {
    let value = '';
    if (event?.target?.value !== undefined) {
      value = event.target.value;
    } else if (event?.detail !== undefined) {
      value = Array.isArray(event.detail) ? event.detail[0] : event.detail;
    } else if (typeof event === 'string') {
      value = event;
    }

    this.localIDformctrl.setValue(value);
    this.validateForm();
    this.changeDetectorRef.detectChanges();
  }

  public onGlobalIdInput(event: any): void {    
    let value = '';
    if (event?.target?.value !== undefined) {
      value = event.target.value;
    } else if (event?.detail !== undefined) {
      value = Array.isArray(event.detail) ? event.detail[0] : event.detail;
    } else if (typeof event === 'string') {
      value = event;
    }
    this.globalIDformctrl.setValue(value);
    this.validateForm();
    this.changeDetectorRef.detectChanges();
  }

  public onCountryValueChange(event: any): void {
    let newValue = event;
    if (event?.detail) {
      newValue = Array.isArray(event.detail) ? event.detail[0] : event.detail;
    } else if (event?.target?.value) {
      newValue = event.target.value;
    }
    this.countriesFormControlOutlinedSmall.setValue(newValue, { emitEvent: false });
    this.validateForm();
    this.changeDetectorRef.detectChanges();
  }

  public onNotificationTypeValueChange(event: any): void {
    let newValue = event;
    if (event?.detail) {
      newValue = Array.isArray(event.detail) ? event.detail[0] : event.detail;
    } else if (event?.target?.value) {
      newValue = event.target.value;
    }
    this.notificationTypeFormControl.setValue(newValue, { emitEvent: false });
    this.isTableShow = false;
    this.validateForm();
    this.validateSearchForm();
    this.changeDetectorRef.detectChanges();
  }

  private resetFormState(): void {
    // Reset state flags FIRST
    this.selectedRadioValue = null;
    this.isTableShow = false;
    this.showCreateLocalSection = false;
    this.dataFlag = false;
    this.dataSource = [];
    this.isCreateDisabled = true;
    this.isDisabledSearch = true;

    // Reset all form controls with emitEvent false to prevent cascading effects
    this.countriesFormControlOutlinedSmall.reset(null, { emitEvent: false });
    this.notificationTypeFormControl.reset(null, { emitEvent: false });
    this.localBasedGlobalNotificationRadioButton.reset(null, { emitEvent: false });
    this.localIDformctrl.reset('', { emitEvent: false });
    this.globalIDformctrl.reset('', { emitEvent: false });
    this.searchNotificationId.reset('', { emitEvent: false });

    // Reset pagination
    this.currentPage = 1;
    this.totalItems = 0;
    this.totalPages = 0;

    // Force change detection to update the view
    this.changeDetectorRef.detectChanges();
  }
  
}

let ELEMENT_DATA= []